<template>
  <Content @back="$router.go(-1)">
    <template v-slot:nav_left>{{centerInfo.youth.youthShortName || '--'}}</template>
    <template v-slot:content_right>
      <div class="mainHead">
        <div class="headInfo">
          <div class="logo">
            <img :src="centerInfo.youth.banner || clubImg" alt="" @error="centerInfo.youth.banner = clubImg">
          </div>
          <div class="info">
            <div class="row">
              <p>全称：{{centerInfo.youth.youthName}}</p>
              <p class="item">等级：{{centerInfo.youth.level}}</p>
            </div>
            <div class="row">
              <p >管理单位：{{centerInfo.youth.organShortName}}</p>
              <p class="item">地址：{{centerInfo.youth.cityName}}{{centerInfo.youth.countyName}}</p>
            </div>
            <div class="row">
              <p >管理员姓名：{{centerInfo.user.idName}}</p>
              <p class="item">管理员手机号：<yioks-privacy-text type="phone" :value="centerInfo.user.phone" /></p>
            </div>
            <div class="row">
              <p >状态：{{centerInfo.youth.status | statusFilter }}</p>
              <p class="item">球队数量：{{centerInfo.youth.squadNum}}</p>
              <p class="item">球员数量：{{centerInfo.youth.playerTeamNum}}</p>
              <p class="item">教练数量：{{centerInfo.youth.coachTeamNum}}</p>
            </div>
          </div>
          <div class="btn">
            <div class="bg_btn" @click="editCenter=true">编辑信息</div>
          </div>
        </div>
      </div>
      <div class="mainInfo">
        <div class="select_wrap">
          <p class="title">
            <strong>球队管理</strong>
          </p>
          <div class="select_box">
            <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="getSquadList()"
            >
            <div class="yioks_btn" @click="getSquadList()">搜索</div>
          </div>
        </div>
        <div v-if="showList" class="list">
          <div class="scrollArea">
            <vue-scroll >
              <div
                v-for="(item, index) in squadList"
                :key="index"
                class="tr">
                <div class="item">
                  <div class="img">
                    <img :src="item.banner || squadImg" alt="" @error="item.banner = squadImg">
                  </div>
                  <div class="info">
                    <p class="title">{{item.shortName}}</p>
                    <p>主教练：{{item.chiefCoachName}}</p>
                    <p>球员数量：{{item.playerTeamNum}}</p>
                  </div>
                  <div class="opt">
                    <div class="bg_btn" @click="goInfo(item.uuid)">查看详情</div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <template v-if="editCenter">
        <AddPlayerDialog
          :addCenter.sync="editCenter"
          :centerUuid="uuid"
          :isEdit="isEdit"
          @hideDialog="hideDialog"></AddPlayerDialog>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import trainCamp from '@/api/club'
import squad from '@/api/squad'
import clubImg from '@/assets/images/common/club.png'
import regions from '@/utils/regions'
import storage from '@/utils/storage'
import squadImg from '@/assets/images/common/squad.png'

import { userStatus, centerStatusList } from '@/utils/yioks_data'
import { centerStatus } from '@/utils/yioks_filter'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/club')
    // 'UploadFile': () => import('@/components/UploadFile')
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    }
  },
  data () {
    return {
      squadImg,
      regions,
      editCenter: false,
      clubImg,
      uuid: '',
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      addCenterBtn: false,
      centerStatusList,
      centerInfo: {
        user: {},
        youth: {}
      },
      loading: false,
      isEdit: true,
      userStatus,
      selectVal: {
        key: ''
      },
      squadList: [],
      userRole: storage.get('userInfo').userRole
    }
  },
  created () {
    const uuid = this.$route.query.uuid
    this.uuid = uuid
    // this.getCoachAccount()
    this.getCenterInfo()
    this.getSquadList()
  },
  methods: {
    getCenterInfo () {
      trainCamp.getCenterInfo(this.uuid).then((res) => {
        this.centerInfo.user = res.user
        this.centerInfo.youth = res.youth
      })
    },
    getSquadList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = squad.getSquadBySystem
      } else if (this.userRole === 'organ') {
        request = squad.getSquadByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getSquadByYouth
      }
      request({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, youthUuid: this.uuid }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.squadList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    goInfo (uuid) {
      this.$router.push({
        path: '/squad/detail',
        query: {
          uuid
        }
      })
    },
    hideDialog (val) {
      this.editCenter = val
      this.getCenterInfo()
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainHead
    padding 15px 20px 0
    .headInfo
      display flex
      padding-bottom 20px
      border-bottom 1px solid white
      .logo
        display: flex;
        justify-content: center;
        align-items: center
        img
          width 105px
      .info
        width: calc(100% - 210px);
        padding 0 10px
        flex  1 1 auto
        .row
          margin 10px 0
          display flex
          .item
            margin 0 15px
      .btn
        width 105px
        display: flex;
        justify-content: center;
        align-items: center
  .mainInfo
    height:430px
    .select_wrap
      display flex
      justify-content space-between
      padding 10px 20px 5px
      .title
        font-size 20px
    .list
      height 375px
      .scrollArea
        height 100%
        .tr
          padding 0 20px
          .item
            display flex
            align-items center
            padding 15px 0
            border-bottom 1px solid #fff
            .img
              img
                width 100px
            .info
              width: calc(100% - 240px);
              padding 0 10px
              p
                margin-bottom 10px
                &:last-child
                  margin-bottom 0
              .title
                font-size 20px
            .opt
              padding 0 10px
              width 140px
              display flex
              align-items center
              justify-content center
.bg_btn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  &:hover
    background #5ac8fa
</style>
